{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Þú hefur farið yfir hámarksfjölda samtala. Hacker áskriftin leyfir aðeins 500 samtöl.",
      "INBOXES": "Þú hefur farið yfir hámarksfjölda innhólfa. Hacker áskriftin styður aðeins vefspjall. Fleiri innhólf, eins og tölvupóstur og WhatsApp, krefjast greiddrar áskriftar.",
      "AGENTS": "Þú hefur farið yfir hámarksfjölda þjónustufulltrúa. Hacker áskriftin leyfir aðeins 2 þjónustufulltrúa.",
      "NON_ADMIN": "Vinsamlegast hafðu samband við stjórnanda þinn til að uppfæra áskriftina og halda áfram að nota alla eiginleika."
    },
    "TITLE": "Aðgangs stillingar",
    "SUBMIT": "Uppfæra stillingar",
    "BACK": "Til baka",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Gat ekki uppfært stillingar, reyndu aftur!",
      "SUCCESS": "Tókst að uppfæra stillingar"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Eyða reikningnum þínum",
      "NOTE": "Þegar þú eyðir reikningnum þínum verða öll gögnin þín eydd.",
      "BUTTON_TEXT": "Eyða reikningnum þínum",
      "CONFIRM": {
        "TITLE": "Eyða reikningi",
        "MESSAGE": "Ekki er hægt að afturkalla eyðingu reiknings. Sláðu inn nafn reikningsins hér að neðan til að staðfesta að þú viljir eyða honum varanlega.",
        "BUTTON_TEXT": "Eyða",
        "DISMISS": "Hætta við",
        "PLACE_HOLDER": "Sláðu inn {accountName} til að staðfesta"
      },
      "SUCCESS": "Reikningur merktur til eyðingar",
      "FAILURE": "Ekki tókst að eyða reikningi, reyndu aftur!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Þessum reikningi er áætlað að eyða þann {deletionDate}. Stjórnandi óskaði eftir þessu. Þú getur hætt við eyðinguna fyrir þennan dag.",
        "MESSAGE_INACTIVITY": "Þessum reikningi er áætlað að eyða þann {deletionDate} vegna óvirkni reikningsins. Þú getur hætt við eyðinguna fyrir þennan dag.",
        "CLEAR_BUTTON": "Hætta við áætlaða eyðingu"
      }
    },
    "FORM": {
      "ERROR": "Vinsamlegast lagfærðu villurnar",
      "GENERAL_SECTION": {
        "TITLE": "Almennar stillingar",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Númer aðgangs",
        "NOTE": "Þetta auðkenni er nauðsynlegt ef þú ert að byggja upp API byggða samþættingu"
      },
      "NAME": {
        "LABEL": "Aðgangsnafn",
        "PLACEHOLDER": "Þitt aðgangsnafn",
        "ERROR": "Vinsamlegast sláðu inn samþykkt aðgangsnafn"
      },
      "LANGUAGE": {
        "LABEL": "Tungumál síðu",
        "PLACEHOLDER": "Þitt aðgangsnafn",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Incoming Email Domain",
        "PLACEHOLDER": "Lénið þar sem þú færð tölvupóstinn",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Þjónustu tölvupóstur",
        "PLACEHOLDER": "Þjónustu tölvupóstur fyrirtækisins",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Fjöldi daga eftir miða ætti að leysast sjálfkrafa ef engin virkni er",
        "NOTE": "Fjöldi klukkustunda án virkni sem veldur því að opið samtal leysist sjálfkrafa.",
        "PLACEHOLDER": "30",
        "ERROR": "Vinsamlega sláðu inn gilda lengd sjálfvirkrar úrlausnar (lágmark 1 dagur og hámark 999 dagar)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Fjöldi daga sem tómt samtal leysist sjálfkrafa eftir ef engin virkni er",
        "PLACEHOLDER": "aldrei",
        "ERROR": "Vinsamlega sláðu inn gilda lengd sjálfvirkrar úrlausnar (lágmark 1 dagur og hámark 999 dagar)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Samfellu samtals með tölvupósti er virkjuð fyrir reikninginn þinn.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Þú getur fengið tölvupóst á þitt lén núna."
      },
      "PHONE": {
        "TITLE": "Stillingar símstöðvar",
        "NOTE": "Stilltu tengingu við símstöðina þína fyrir símtöl",
        "SIP_HOST": {
          "LABEL": "SIP lén"
        },
        "DIALING_MODE": {
          "LABEL": "Hringingarhamur",
          "MODES": {
            "direct": "Beint – hringt er samstundis þegar smellt er á símatengil",
            "indirect": "Óbeint – símanúmerið er sett í innsláttarreit símagræjunnar"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Aðgangur að símtalsupptökum",
          "MODES": {
            "admin_only": "Aðeins stjórnendur",
            "admin_and_assigned_agent": "Stjórnendur og úthlutaður þjónustufulltrúi",
            "inbox_members": "Allir þjónustufulltrúar með aðgang að innhólfinu"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Tölvupóstsstillingar",
        "NOTE": "Breytir hegðun tölvupóstsinnhólfa"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Birtingarhamur tímastimpils samtals",
        "MODES": {
          "both": "Stofnað og síðasta virkni",
          "last_activity_only": "Aðeins síðasta virkni",
          "last_customer_message": "Síðustu skilaboð viðskiptavinar"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Loka á lén með lélegt orðspor"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Hafa upprunalegu skilaboðin með í svari við tölvupóstinum"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Leysa nýtt samtal sjálfkrafa"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Færa nýtt tölvupóstsamtal sjálfkrafa í pósthólf vélmennisins sem afgreiddi pantanir tengiliðarins"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Útvíkkaðar merkingar – leyfa lengri nöfn merkinga með stærra sprettiglugga"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent – úthlutar samtali sjálfkrafa til þjónustufulltrúans sem sendi síðasta svarið"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Hamur ýti-tilkynninga",
        "MODES": {
          "all_inboxes": "Öll innhólf – senda tilkynningar fyrir allar tegundir rása",
          "chat_only": "Aðeins spjall – senda tilkynningar aðeins fyrir aðrar rásir en tölvupóst"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Leyfa að kveikja/slökkva á undirskrift í sendum skilaboðum"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Birta spjallstöðu þjónustufulltrúa á Wallboard skjánum"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Sýna heiti viðhengja að fullu án styttingar"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Innskráning með lykilorði",
        "MODES": {
          "allowed_for_all": "Leyfilegt fyrir alla notendur",
          "allowed_for_agents_only": "Leyfilegt aðeins fyrir þjónustufulltrúa (stjórnendur verða að nota OAuth)",
          "password_login_disabled": "Óvirkt – aðeins OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Ný útgáfa í boði. Endurhladdu til að fá nýjustu uppfærslurnar.",
    "RELOAD_NOW": "Uppfæra núna",
    "LEARN_MORE": "Læra meira",
    "PAYMENT_PENDING": "Greiðslan þín er í bið. Vinsamlegast uppfærðu greiðsluupplýsingarnar þínar til að halda áfram að nota hugbúnaðinn",
    "LIMITS_UPGRADE": "Reikningurinn þinn hefur farið yfir notkunarmörkin. Vinsamlegast uppfærðu áskriftarleiðina þína til að halda áfram að nota hugbúnaðinn",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Enter til þess að velja",
      "ENTER_TO_REMOVE": "Enter til þess að fjarlægja",
      "NO_OPTIONS": "Listinn er tómur",
      "NO_RESULT": "Engar niðurstöður fundust",
      "SELECT_ONE": "Veldu eitt",
      "SELECT": "Velja"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Skilaboð",
    "MARK_ALL_DONE": "Merkja allt tilbúð",
    "DELETE_TITLE": "eyða",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Ólesnar tilkynningar",
      "ALL_NOTIFICATIONS": "Skoða allar tilkynningar",
      "LOADING_UNREAD_MESSAGE": "Hleð ólesnum skilaboðum...",
      "EMPTY_MESSAGE": "Þú átt enginn ólesin skilaboð"
    },
    "LIST": {
      "LOADING_MESSAGE": "Hleð skilaboðum...",
      "404": "Engin skilaboð",
      "TABLE_HEADER": [
        "Nafn",
        "Símanúmer",
        "Samtöl",
        "Síðast samband"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nýtt samtal",
      "conversation_assignment": "Samtali úthlutað",
      "assigned_conversation_new_message": "Nýtt skilaboð",
      "participating_conversation_new_message": "Nýtt skilaboð",
      "conversation_mention": "Nefna",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Uppfæra"
    },
    "CONNECTION_LOST": {
      "TITLE": "Tenging rofnaði",
      "DESCRIPTION": "Ekki tókst að ná sambandi við netþjóninn. Athugaðu tenginguna og reyndu aftur.",
      "RETRY": "Reyna aftur"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Leita eða stökkva til",
    "SECTIONS": {
      "GENERAL": "Almennar",
      "REPORTS": "Skýrslur",
      "CONVERSATION": "Samtal",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Breyta úthlutun",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Breyta Teymi",
      "SNOOZE_CONVERSATION": "Fresta Samtali",
      "EXECUTE_MACRO": "Keyra fjölva",
      "ADD_LABEL": "Merkja samtalið",
      "REMOVE_LABEL": "Fjarlægja merki af samtali",
      "SETTINGS": "Stillingar",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Opna Stjórnborð Samtals",
      "GO_TO_CONTACTS_DASHBOARD": "Opna Stjórnborð Tengiliða",
      "GO_TO_REPORTS_OVERVIEW": "Opna yfirlit Skýrslna",
      "GO_TO_CONVERSATION_REPORTS": "Opna Samtals Skýrslur",
      "GO_TO_AGENT_REPORTS": "Opna Þjónustufulltrúa Skýrslur",
      "GO_TO_LABEL_REPORTS": "Opna Merkja Skýrslur",
      "GO_TO_INBOX_REPORTS": "Opna Innhólfs Skýrslur",
      "GO_TO_TEAM_REPORTS": "Opna Teymis Skýrslur",
      "GO_TO_SETTINGS_AGENTS": "Opna Stillingar Þjónustufulltrúa",
      "GO_TO_SETTINGS_TEAMS": "Opna Stillingar Teymis",
      "GO_TO_SETTINGS_INBOXES": "Opna Stillingar Innhólfs",
      "GO_TO_SETTINGS_LABELS": "Opna Stillingar Merkja",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Opna Stillingar Staðlaðra Svara",
      "GO_TO_SETTINGS_APPLICATIONS": "Opna Stillingar Forrits",
      "GO_TO_SETTINGS_ACCOUNT": "Opna Stillingar Aðgangs",
      "GO_TO_SETTINGS_PROFILE": "Opna Stillingar Prófíls",
      "GO_TO_NOTIFICATIONS": "Opna Tilkynningar",
      "ADD_LABELS_TO_CONVERSATION": "Merkja samtalið",
      "ASSIGN_AN_AGENT": "Úthluta á þjónustufulltrúa",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Úthluta á teymi",
      "EXECUTE_A_MACRO": "Keyra fjölva",
      "MUTE_CONVERSATION": "Þagga samtal",
      "UNMUTE_CONVERSATION": "Afþagga samtal",
      "REMOVE_LABEL_FROM_CONVERSATION": "Fjarlægja merki af samtali",
      "REOPEN_CONVERSATION": "Enduropna samtal",
      "RESOLVE_CONVERSATION": "Leysa samtal",
      "SEND_TRANSCRIPT": "Senda afrit með tölvupósti",
      "SNOOZE_CONVERSATION": "Fresta Samtali",
      "UNTIL_NEXT_REPLY": "Þar til að næsta svar berst",
      "UNTIL_NEXT_WEEK": "Þar til í næstu viku",
      "UNTIL_TOMORROW": "Þar til á morgun",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Hleð Stjórnborði..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "smelltu hér"
  }
}
